export default "__VITE_ASSET__s$wnFm0m__"